export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=da9a79ae&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/services/index.vue?vue&type=template&id=da9a79ae&
// module id = 1148
// module chunks = 0